import type { FC } from "react";

/** Animation delay per dot of the 3×3 grid, rippling out from the left-middle dot. */
const DOT_DELAYS = Array.from({ length: 9 }, (_value, index) => {
  const row = Math.floor(index / 3);
  const column = index % 3;
  return (column + Math.abs(row - 1)) * 90;
});

/**
 * The agent's working indicator: a 3×3 dot grid, sized to sit in the same slot
 * as a tool call's status icon. Takes the current text color.
 */
export const ThinkingDots: FC = () => (
  <span
    aria-hidden
    className="mx-px grid shrink-0 grid-cols-[repeat(3,4px)] gap-px"
  >
    {DOT_DELAYS.map((delay, index) => (
      <span
        key={index}
        className="size-1 animate-thinking-dot-wave rounded-full bg-current opacity-15 motion-reduce:animate-none"
        style={{ animationDelay: `${delay}ms` }}
      />
    ))}
  </span>
);
